import { useState } from "react";
import { maxSpaceSlugLength } from "../../shared/edgeUrl";
import { slugValidationError } from "../../shared/slug";
import { useSessionTenantEdgeUrlOptions } from "./useSessionTenantOrigin";

export function useSlugField({
  currentSlug,
  allItems,
  currentId,
  onCommit,
}: {
  currentSlug: string | undefined;
  allItems: readonly { id: string; slug: string }[];
  currentId: string;
  onCommit: (slug: string) => void;
}) {
  const maxLength = maxSpaceSlugLength(useSessionTenantEdgeUrlOptions());
  const [editValue, setEditValue] = useState<string | null>(null);
  const value = editValue ?? currentSlug ?? "";

  const error =
    editValue !== null && editValue !== ""
      ? slugValidationError(editValue, maxLength)
      : null;
  const slugTaken =
    editValue !== null &&
    editValue !== currentSlug &&
    allItems.some((item) => item.id !== currentId && item.slug === editValue);

  const commit = () => {
    if (editValue === null) return;
    if (
      editValue === "" ||
      editValue === currentSlug ||
      error !== null ||
      slugTaken
    ) {
      setEditValue(null);
      return;
    }
    onCommit(editValue);
    setEditValue(null);
  };

  return { value, setValue: setEditValue, error, slugTaken, commit };
}
